import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet, Event as RouterEvent } from '@angular/router';

import { Subscription, async, filter } from 'rxjs';
import { Balance, WalletInfo } from '../../source/modules/cashier/balance';
import { Store } from '@ngrx/store';
import { SlotsService } from '../../source/services/slotsservice/slots.service';
import { PlayerService } from '../../source/services/player/player.service';
import * as loginActions from '../../source/appstates/loginstates/loginActions'
import * as appState from '../../source/appstates/appState'
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions'
import { LoginState } from '../../source/appstates/loginstates/loginState';
import { PlayerGetProfile } from '../../source/appstates/playerstates/playerActions';
import { ProfileState } from '../../source/appstates/playerstates/playerState';
import { CashierState } from '../../source/appstates/cashierstates/cashierState';
import { QuickloginComponent } from '../quicklogin/quicklogin.component';
import { NgxMarqueeModule } from 'ngx-marquee';
import { FooterComponent } from '../footer/footer.component';
import { GamesService } from '../../source/services/games/games.service';
import { QRCodeModule } from 'angularx-qrcode';
import { CommondataService } from '../../source/services/games/commondata.service';
import { FormsModule } from '@angular/forms';
import { FooterProviderComponent } from '../../footer-provider/footer-provider.component';
import { AllGameproviderComponent } from '../../all-gameprovider/all-gameprovider.component';
import { HistoryPageComponent } from '../history-page/history-page.component';
import { Profile } from '../../source/modules/player/profile';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { timer, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from '../../source/services/login/login.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProfileComponent } from '../player/profile/profile.component';
import { DepositComponent } from '../cashier/deposit/deposit.component';
import { WithdrawComponent } from '../cashier/withdraw/withdraw.component';
import { TransactionHistoryComponent } from '../transaction-history/transaction-history.component';
import { CasinoHistoryComponent } from '../casino-history/casino-history.component';
import { MyaccountComponent } from '../myaccount/myaccount.component';

import { ChangeDetectionStrategy } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslateModule, FooterComponent, FooterProviderComponent, AllGameproviderComponent,
    ProfileComponent, DepositComponent, WithdrawComponent, QRCodeModule, RouterModule, FormsModule, RouterOutlet,
    RouterLink, NgxMarqueeModule, TransactionHistoryComponent, CasinoHistoryComponent, MyaccountComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  //  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<void>();
  @ViewChild("profileDropdown") profileDropdown!: ElementRef;
  urlSafe: SafeResourceUrl | null = null;
  private destroy$ = new Subject<void>();
  logoutPopup: boolean = false;
  Appmenu!: boolean;
  openProfile: boolean = false;
  allproiderGames: boolean = false;
  showPopupHot = false;
  showPopupSports = false;
  showPopupcasino = false;
  showPopupInstant = false;
  isOpenTermsAndCondition: boolean = false;
  isPrivacyPolicy: boolean = false;
  isTermsAndCondition: boolean = false;
  popupType: string = '';
  isPopupOpen = false;
  selectedAvtarId: any;
  private storeSub!: Subscription;
  private closeSub!: Subscription;
  showCopiedMessage = false;
  selectedTab: string = 'casino';
  private storeProfileSub!: Subscription;
  playerName: any;
  indexId: any = 1000;
  cashier!: Balance;
  walleteInfo: WalletInfo[] = [];
  balance: any;
  userCompoints: any;
  lightTheme: boolean = false;
  playertype: any;
  playerLoggedIn: boolean = false;
  menuNames: boolean = true;
  openRegister: boolean = false;
  HandleRegSuccess: boolean = false;
  casinomessage: string = '';
  previewAvtar: string = "";
  casinogamessuccessPop: boolean = false;
  openClo: boolean = false;
  menushow: boolean = false;
  shodrop: any;
  closeMenuCoverDiv: boolean = false;
  sessionExpiresuccessPop: boolean = false;
  sessionmessage: string = "";
  @ViewChild('alertHost', { read: ViewContainerRef }) alertHost!: ViewContainerRef;
  showDiv: boolean = true;
  loginSub!: Subscription;
  profileHeader: boolean = false;
  profileAvathar: boolean = false;
  cashuser: any;
  bounsuser: any;
  bounsuserWager: any;
  providerList2: any;
  providerList: Set<string> = new Set();

  hidedeposit: boolean = false
  hidecashout: boolean = false
  statusMessage: boolean = true;
  isDepositMesPop: boolean = false;
  gadgetType: any;
  showAvtars: boolean = false;
  isOpenIosPop: boolean = false;
  ismobile: boolean = false;
  currentActiveIndex: number = 0;
  showProvider: boolean = false;
  activeMenu: string = '';
  selectedLang: any = localStorage.getItem('lang') || 'BN';
  languages = [
    { code: 'EN', label: 'English' },
    { code: 'BN', label: 'বাংলা' }
  ];
  openClose: boolean = false;
  tempLang: any = localStorage.getItem('lang');
  @ViewChild('avatarDropdown', { static: false }) avatarDropdownRef!: ElementRef;
  @ViewChild('balanceDropdown', { static: false }) balanceDropdownRef!: ElementRef;
  links: Array<any> = [
    // { name: 'MENU', active: false, icon: 'fa-bars', router: 'MENU' },
    // { name: 'Back', active: false, icon: 'fa-arrow-left', router: 'menu' },
    { name: 'HOME', active: true, icon: 'fa-home', router: 'home', iconimg: "../../../assets/sitelogos/Home.svg" },
    { name: 'Promotions', active: false, icon: 'fa-futbol', router: 'promotions', iconimg: "../../../assets/sitelogos/Promotions.svg" },
    { name: 'DEPOSIT', active: false, icon: '', router: 'deposit', iconimg: "../../../assets/siteImg/profiledrop_icon/icon-deposit.png" },
    { name: 'PROFILE', active: false, icon: '', router: 'myaccount', iconimg: "../../../assets/siteImg/profiledrop_icon/icon-profile.png" },
    // { name: 'AVIATOR', active: false, icon: 'fa-futbol', router: 'aviator' },
    // { name: 'SEARCH', active: false, icon: 'fas fa-search' },
    // { name: 'SLOTS', active: false, icon: 'fa-quidditch', router: 'slots' },
    // { name: 'SEARCH', active: false, icon: 'fa-search', router: 'sports'  },
  ];
  profile!: Profile;
  gifLoader: boolean = false
  searchProvider: any;
  referFriend: any;
  avatarList: any;
  errorMsg: any;
  vipLevels: any[] = [];
  vipName: any;
  vipName1: any;
  playerStatisticsSec: boolean = false;
  currentRank: any = 'Unranked';
  nextRankIcon: any = 'Bronze';
  vipProgress: any = 0;
  playerStatistics: any = [];
  clanIframePop: boolean = false;
  isLoading: boolean = false;
  isExchange: boolean = false;
  provider: any;
  menu: any = [
    {
      "name": "Home",
      "icon": "fa fa-home",
      "router": "/home"
    },
    {
      "name": "Hot Games",
      "icon": "fa fa-fire",
      "children": [
        {
          "name": "Golden Unicorn Deluxe",
          "media": "../../../assets/siteImg/HotGames/SGGoldenUnicornDeluxe.webp",
          "status": true,
          "router": "",
          "gameName": "Golden Unicorn Deluxe",
          "displayName": "Golden Unicorn Deluxe",
          "KeyName": "SGGoldenUnicornDeluxe",
          "provider": "Habanero"
        },
        {
          "name": "Mystic Fortune Deluxe",
          "media": "../../../assets/siteImg/HotGames/SGMysticFortuneDeluxe.webp",
          "status": true,
          "router": "",
          "gameName": "Mystic Fortune Deluxe",
          "displayName": "Mystic Fortune Deluxe",
          "KeyName": "SGMysticFortuneDeluxe",
          "provider": "Habanero"
        },
        {
          "name": "Wealth Inn",
          "media": "../../../assets/siteImg/HotGames/SGWealthInn.webp",
          "status": true,
          "router": "",
          "gameName": "Wealth Inn",
          "displayName": "Wealth Inn",
          "KeyName": "SGWealthInn",
          "provider": "Habanero"
        },
        {
          "name": "Lantern Luck",
          "media": "../../../assets/siteImg/HotGames/SGLanternLuck.webp",
          "status": true,
          "router": "",
          "gameName": "Lantern Luck",
          "displayName": "Lantern Luck",
          "KeyName": "SGLanternLuck",
          "provider": "Habanero"
        },
        {

          "name": "Before Time Runs Out",
          "media": "../../../assets/siteImg/HotGames/SGBeforeTimeRunsOut.webp",
          "status": true,
          "router": "",
          "gameName": "Before Time Runs Out",
          "displayName": "Before Time Runs Out",
          "KeyName": "SGBeforeTimeRunsOut",
          "provider": "Habanero"

        },
        {

          "name": "Bombs Away",
          "media": "../../../assets/siteImg/HotGames/SGBombsAway.webp",
          "status": true,
          "router": "",
          "gameName": "Bombs Away",
          "displayName": "Bombs Away",
          "KeyName": "SGBombsAway",
          "provider": "Habanero"

        },
        {

          "name": "Egyptian Dreams",
          "media": "../../../assets/siteImg/HotGames/SGEgyptianDreams.webp",
          "status": true,
          "router": "",
          "gameName": "Egyptian Dreams",
          "displayName": "Egyptian Dreams",
          "KeyName": "SGEgyptianDreams",
          "provider": "Habanero"

        },
        {

          "name": "Fire Rooster",
          "media": "../../../assets/siteImg/HotGames/SGFireRooster.webp",
          "status": true,
          "router": "",
          "gameName": "Fire Rooster",
          "displayName": "Fire Rooster",
          "KeyName": "SGFireRooster",
          "provider": "Habanero"

        },
        {
          "name": "Glory Of Rome",
          "media": "../../../assets/siteImg/HotGames/SGGloryOfRome.webp",
          "status": true,
          "router": "",
          "provider": "Habanero",
          "KeyName": "SGGloryOfRome",
          "gameName": "Glory Of Rome",
          "displayName": "Glory Of Rome"

        },
        {
          "name": "Fruity Mayan",
          "media": "../../../assets/siteImg/HotGames/SGFruityMayan.webp",
          "status": true,
          "router": "",
          "provider": "Habanero",
          "KeyName": "SGFruityMayan",
          "gameName": "Fruity Mayan",
          "displayName": "Fruity Mayan"
        },
        {
          "media": "../../../assets/siteImg/HotGames/SGJump.webp",
          "status": true,
          "router": "",
          "gameName": "Jump",
          "name": "Jump",
          "KeyName": "SGJump",
          "provider": "Habanero"
        },
        {
          "media": "../../../assets/siteImg/HotGames/SGKnockoutFootballRush.webp",
          "status": true,
          "router": "",
          "gameName": "Knockout Football Rush",
          "name": "Knockout Football Rush",
          "KeyName": "SGKnockoutFootballRush",
          "provider": "Habanero"
        },
        {
          "media": "../../../assets/siteImg/HotGames/SGLoonyBlox.webp",
          "status": true,
          "router": "",
          "gameName": "Loony Blox",
          "name": "Loony Blox",
          "KeyName": "SGLoonyBlox",
          "provider": "Habanero"

        },
        {
          "media": "../../../assets/siteImg/HotGames/SGMightyMedusa.webp",
          "status": true,
          "router": "",
          "gameName": "Mighty Medusa",
          "name": "Mighty Medusa",
          "KeyName": "SGMightyMedusa",
          "provider": "Habanero"

        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGNaughtyWukong.webp",
          "provider": "Habanero",
          "KeyName": "SGNaughtyWukong",
          "gameName": "Naughty Wukong",
          "name": "Naughty Wukong"
        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGPoseidon.webp",
          "provider": "Habanero",
          "KeyName": "SGPoseidon",
          "gameName": "Poseidon",
          "name": "Poseidon"
        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGProst.webp",
          "gameName": "Prost!",
          "name": "Prost!",
          "KeyName": "SGProst",
          "provider": "Habanero"
        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGRainbowmania.webp",
          "provider": "Habanero",
          "KeyName": "SGRainbowmania",
          "gameName": "Rainbow mania",
          "name": "Rainbow mania"
        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGScopa.webp",
          "gameName": "Scopa",
          "name": "Scopa",
          "KeyName": "SGScopa",
          "provider": "Habanero"
        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGSirensSpell.webp",
          "provider": "Habanero",
          "KeyName": "SGSirensSpell",
          "gameName": "Sirens Spell",
          "name": "Sirens Spell"
        },
        {
          "status": true,
          "router": "",
          "media": "../../../assets/siteImg/HotGames/SGTotemTowers.webp",
          "gameName": "Totem Towers",
          "name": "Totem Towers",
          "KeyName": "SGTotemTowers",
          "provider": "Habanero"
        }

      ]
    },
    {
      "name": "Slots",
      "icon": "fa fa-slot-machine",
      "expanded": false,
      "children": [
        {
          "name": "jdb",
          "router": "/slots",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_jdb.png?v=1776751585638&source=mcdsrc"
        },
        {
          "name": "jilli",
          "router": "/slots",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_jili.png?v=1776751585638"
        },
        // {
        //   "name": "gtf",
        //   "router": "/slots",
        //   "status": true,
        //   "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_gtf.png?v=1776751585638"
        // },
        {
          "name": "habanero",
          "router": "/slots",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Hebanero.png"
        },
        {
          "name": "pragmaticplay",
          "router": "/slots",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_pp.png?v=1776751585638"
        },
        {
          "name": "spribe",
          "router": "/slots",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_spribe.png?v=1776751585638"
        },
        // {
        //   "name": "platipus",
        //   "router": "/slots",
        //   "status": true,
        //   "media": "../../../assets/siteImg/sidemenu_icons_provider/Platipus.png"
        // },
        {
          "name": "tomhorn",
          "router": "/slots",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Tom-Hprn.png"
        },
        {
          "name": "kagaming",
          "router": "/slots",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-ka.png?v=1776751585638"
        },
        {
          "name": "aviatrix",
          "router": "/slots",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Aviatrix.png"
        },
        {
          "name": "nucleus",
          "router": "/slots",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Nucleus.png"
        },
        {
          "name": "kingmidas",
          "router": "/slots",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/kingmidas.png"
        },
        {
          "name": "netentGV",
          "displayName": "netent",
          "router": "/slots",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_netent.png?v=1776751585638"
        },
        {
          "name": "18peaches",
          "router": "/slots",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/18peaches.png"
        }
      ]
    },
    {
      "name": "Crash",
      "icon": "fa fa-futbol",
      "expanded": false,
      "children": [
        {
          "name": "Aviator",
          "router": "/aviator",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_spribe.png?v=1776751585638"
        },
        {
          "name": "Aviatrix",
          "router": "/aviator",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Aviatrix.png"
        }
      ]
    },
    {
      "name": "Casino",
      "icon": "fa fa-futbol",
      "expanded": false,
      "children": [
        {
          "name": "Sexy",
          "router": "/livecasino",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_sexybcrt.png?v=1777968960008"
        },
        {
          "name": "EvolutionGV",
          "displayName": "Evolution",
          "router": "/livecasino",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_evolution.png?v=1776751585638"
        },
        {
          "name": "EzugiGV",
          "displayName": "Ezugi",
          "router": "/livecasino",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Ezugi.png"
        },
        {
          "name": "pragmaticplaylivecasino",
          "router": "/livecasino",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_pp.png?v=1776751585638"
        },
        {
          "name": "Vivogaming",
          "router": "/livecasino",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/vivo.png"
        }
      ]
    },
    {
      "name": "Sports",
      "icon": "fa fa-futbol",
      "expanded": false,
      "children": [
        // {
        //   "name": "BTI",
        //   "router": "/sports",
        //   "status": true,
        //   "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-sbtech.png?v=1776751585638"
        // },
        {
          "name": "9 Wickets",
          "router": "sports",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/9wickets.ico"
        }
      ]
    },
    {
      "name": "Table",
      "icon": "fa fa-futbol",
      "expanded": false,
      "children": [
        {
          "name": "Balla Games",
          "router": "/ballagames",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/Balla-Games.png"
        },
        // {
        //   "name": "jbd",
        //   "router": "/table",
        //   "status": true,
        //   "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_jdb.png?v=1776751585638&source=mcdsrc"
        // },
        // {
        //   "name": "pp",
        //   "router": "/table",
        //   "status": true,
        //   "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_pp.png?v=1776751585638"
        // }
      ]
    },
    {
      "name": "Lottery",
      "icon": "fa fa-futbol",
      "expanded": false,
      "children": [
        {
          "name": "we are lotto",
          "router": "/lottery",
          "status": true,
          "media": "../../../assets/siteImg/sidemenu_icons_provider/We-are-lottery.png"
        }
      ]
    },
    {
      "name": "Fishing",
      "icon": "fa fa-futbol",
      "expanded": false,
      "children": [
        {
          "name": "jilli",
          "router": "/fishing",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_jili.png?v=1776751585638"
        },
        {
          "name": "kagaming",
          "router": "/fishing",
          "status": true,
          "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-ka.png?v=1776751585638"
        },
        // {
        //   "name": "jdb",
        //   "router": "/fishing",
        //   "status": true,
        //   "media": "https://img.d4040p.com/dp/h5/assets/images/brand/white/provider-awcv2_jdb.png?v=1776751585638&source=mcdsrc"
        // }
      ]
    },
    {
      "name": "Promotions",
      "icon": "fa fa-futbol",
      "expanded": false,
      "router": "/promotions",
      // "children": []
    },
    // {
    //   "name": "Vip Program",
    //   "icon": "fa fa-futbol",
    //   "expanded": false,
    //   "children": []
    // },
    // {
    //   "name": "Contact Us",
    //   "icon": "fa fa-futbol",
    //   "expanded": false,
    //   "children": []
    // }
  ]
  modalType: any;
  showDownloadBanner = false;
  mobileView = false;
  isAndroidpop = false;
  @ViewChild('menuContainer') menuContainer!: ElementRef;
  tokendata: any;
  keyname: any;
  slotsdata: any;
  gamelunchurl: any;
  loader_Games: any;
  popnametranslate: any;
  isAndroid: boolean = false;
  lockedBonus: any;
  MobilwBottomMenu: boolean = true
  constructor(private store: Store<appState.AppState>,
    private cdr: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private slotsService: SlotsService,
    private gamesService: GamesService,
    private PlayerService: PlayerService,
    private loginService: LoginService,
    public sanitizer: DomSanitizer,
    public router: Router, private route: ActivatedRoute, private gameService: GamesService, private comman: CommondataService, private translate: TranslateService) {
    const lang: any = localStorage.getItem('lang');
    if (lang) {
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
    } else {
      localStorage.setItem('lang', 'BN')
      this.translate.setDefaultLang('BN');
      this.translate.use('BN');
    }
    const params1 = new URLSearchParams(window.location.search);
    console.log(params1)
    var urlTokenForgot = params1.get('token');
    var urlEventTypeForgot = params1.get('eventType');
    console.log(params1, urlTokenForgot, urlEventTypeForgot)
    if (urlEventTypeForgot == 'registration') {
      let payload = {
        "token": urlTokenForgot,
        "face": "pkrmaster",
        "language": 'en'
      }
      this.loginService.verifyAccount(payload).subscribe((data: any) => {
        this.router.navigate(['/home'])
        if (data['success'] == true) {
          this.casinogamessuccessPop = true
          this.casinomessage = "E-mail verified successfully. Happy Playing !!!"

        } else if (data['success'] == false) {
          this.casinogamessuccessPop = true
          this.casinomessage = data.description

        }
      })
    }
  }
  ngOnInit() {

    this.mobileView = window.innerWidth <= 768;

    this.isAndroidpop = /Android/i.test(navigator.userAgent);

    const bannerClosed = sessionStorage.getItem('app_banner_closed');

    // ONLY BEFORE LOGIN + HOME PAGE
    if (
      this.isAndroidpop &&
      this.mobileView &&
      !this.playerLoggedIn &&
      this.router.url === '/home'
    ) {
      setTimeout(() => {
        this.showDownloadBanner = true;
      }, 1500);

    }

    this.checkDevice();
    // ✅ run once on load (for direct URL like /home?modal=deposit)
    this.updateFromUrl(this.router.url);

    // ✅ run on every navigation
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.updateFromUrl(e.urlAfterRedirects || e.url);
      });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (window.innerWidth <= 850) {
          this.updateActiveRoute();
        }
      });
    this.updateActiveRoute();
    var selectColor = localStorage.getItem('color')
    if (selectColor) {
      this.setTheme(selectColor)
    }
    setTimeout(() => {
      this.showProvider = true;
    }, 2500)
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var url = window.location.href;
    let url2 = url.split('wsession=')[1];
    if (url2) {
      var body: any = {
        "success": true,
        "sessionId": url2
      }
      this.store.dispatch(new loginActions.LoginSuccess(body));
    }
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    this.gadgetType = isMobile ? "Phone" : "Desktop";

    this.storeSub = this.store.select("loginState").subscribe((loginState: LoginState) => {
      if (loginState?.playerLoggedIn) {
        if (loginState.playerLoggedIn.loggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
          this.store.dispatch(new cashierActions.CashierGetBalanceStart());
          this.getBalance()
          this.Profile()
          this.gifLoader = true;
          this.PlayerService.onPlayerGetProfile().subscribe(data => {
            //  this.gamesService.fetchAllGames11(data)
            localStorage.setItem("playerProfileName", data.login)
            if (data.deposits == false) {
              this.hidedeposit = false;
              sessionStorage.setItem("Dp", "false")
            } else {
              this.hidedeposit = true;
              sessionStorage.setItem("Dp", "true")
            }
            if (data.withdrawal == false) {
              this.hidecashout = false;
              sessionStorage.setItem("widl", "false")
            } else {
              this.hidecashout = true;
              sessionStorage.setItem("widl", "true")
            }
          });
        } else {
          this.playerLoggedIn = false;
          // this.gamesService.fetchAllGames11(false)
        }
      }
      if (loginState.forgotPasswordResponse) {
        if (loginState.forgotPasswordResponse.success === true) {
          this.casinomessage = "Password sent successfully to the registered Email ID";
          this.casinogamessuccessPop = true;
        }
      }
    })
    timer(0, 5000)
      .pipe(
        takeUntil(this.destroy$),
        filter(() => this.playerLoggedIn)
      )
      .subscribe(() => {
        this.store.dispatch(new cashierActions.CashierGetBalanceStart());
        this.getBalance();
        this.slotsService.btisportsjsfile();
      });
    if (this.router.url.indexOf('/register') !== -1 || this.router.url.indexOf('/referrer') !== -1) {
      setTimeout(() => {
        const queryString = window.location.href;
        const urlParams = new URL(queryString).searchParams;
        const productID = urlParams.get('ID');
        if (productID) {
          localStorage.setItem('referrer', productID)
        }
        if (this.playerLoggedIn == false) {
          this.showPopUp('REGISTER');
        } else {
        }
      }, 1000);
    }
    this.storeSub = this.store.select("cashierState").subscribe(
      (cashierState: CashierState) => {
        if (cashierState.sessionexpire) {
          if (cashierState.sessionexpire.session) {
            this.sessionmessage = "SESSION_HAS_EXPIRED";
            this.sessionExpiresuccessPop = true;
          } else { }
        }
      });
    const cleanPath = window.location.pathname.slice(1);
    this.activeMenu = cleanPath
    this.getMenuFromPath(this.activeMenu)
    this.router.events
      .pipe(
        filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        // var activeCls = this.comman.getPreviousUrl()
        const url = event.urlAfterRedirects || event.url;
        if (url.includes('/GameLaunch')) {
          this.allproiderGames = false;
        } else {
          // this.allproiderGames = true;

        }
        if (url === '/sports') {
          this.selectedTab = 'sports';
        } else {
          this.selectedTab = 'casino';
        }
      });
    this.getActiveProviders()

    // this.slotsService.walletupdate().subscribe()

    this.comman.gameUrl$.subscribe((url: any) => {

      if (!this.isIphoneSafari()) {
        return;
      }

      if (url) {
        // Game opened
        this.MobilwBottomMenu = false;
      } else {
        // Game closed
        this.MobilwBottomMenu = true;
      }

    });
  }
  @HostListener('window:resize')
  onResize() {
    this.checkDevice();
  }

  isIphoneSafari(): boolean {
    const ua = navigator.userAgent;
    return (
      /iPhone/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) &&
      !/FxiOS/.test(ua) &&
      !/EdgiOS/.test(ua)
    );
  }

  checkDevice() {
    const ua = navigator.userAgent.toLowerCase();

    // Android detection
    const isAndroidUA = ua.includes('android');

    // Optional: treat small screens as mobile (devtools case)
    const isMobileScreen = window.innerWidth <= 768;

    this.isAndroid = isAndroidUA && isMobileScreen;
  }
  downloadApp() {
    const link = document.createElement('a');
    link.href = 'https://gambaji.com/download/mobile/Gambaji.apk';
    link.download = 'Gambaji.apk'; // force download
    link.target = '_self'; // stay in same tab
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  getActiveProviders() {
    this.gamesService.providerList$.subscribe((res: any) => {
      if (res) {
        this.providerList = res
        console.log(this.providerList)
      }
    })
  }
  getMenuFromPath(url: string) {
    if (!this.playerLoggedIn && url === "vip-program") {
      this.showPopUp("LOGIN");
    } else if (url == 'vip-program') {
      this.isExchange = !this.isExchange
    } else {
      this.activeMenu = url
      localStorage.removeItem('P_R_N');
    }
  }
  myprofile() {
    this.openProfile = !this.openProfile;
    if (this.openProfile) {
      setTimeout(() => {
        this.scrollToDown();
      }, 100);
    }
  }
  scrollToDown() {
    if (this.profileDropdown) {
      this.profileDropdown.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  }

  ngAfterViewChecked() {
    let logkey = sessionStorage.getItem('logkey')
    if (logkey) {

    } else {
      // console.clear();
    }
    // console.clear();
    if (this.router.url == '/home?status=Created' || this.router.url == 'home?status=Created') {
      console.log(this.router.url, "kkkkkkkkkkkkkkkkkkk")
      this.comman.close()

    }

  }

  onDeposit() {
    if (this.gadgetType == 'Desktop') {
      this.isDepositMesPop = true;
    } else {
      this.router.navigate(['/deposit'])
    }
  }
  Profile() {
    this.store.dispatch(new PlayerGetProfile());
    this.storeSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {
        if (playerState.profile) {
          this.profile = playerState.profile;

        }
      });
    this.PlayerService.onPlayerGetPlayerLevels().subscribe((data: any) => {
      if (data) {
        this.vipLevels = data.playerLevelResponses;
        for (let i = 0; i < this.vipLevels.length; i++) {
          this.vipName = this.vipLevels[i].name;
          sessionStorage.setItem('vip', this.vipName)
          this.vipName1 = this.vipLevels[i].priority;
        }
      }
    });

  }
  getBalance() {
    this.storeSub = this.store.select("cashierState").subscribe(
      (cashierState: CashierState) => {
        if (cashierState.sessionexpire) {
          if (cashierState.sessionexpire.session) {
            this.sessionmessage = "SESSION_HAS_EXPIRED";
            this.sessionExpiresuccessPop = true;
          }
        };
        if (cashierState.balance) {
          if (cashierState.balance.values) {
            this.walleteInfo = cashierState.balance.values;
            for (let wallet of this.walleteInfo) {
              if (wallet.symbol) {
                this.gifLoader = false;
                this.cashuser = wallet.cash.value;
                this.bounsuser = wallet.bonus.value;
                sessionStorage.setItem("cashuser", this.cashuser)
                sessionStorage.setItem("bounsuser", this.bounsuser)
                this.balance = Number(wallet.cash.value + wallet.bonus.value).toFixed(2);
                sessionStorage.setItem("balance", this.balance)
                sessionStorage.setItem("symbol", wallet.symbol[0])
                sessionStorage.setItem("wallet", wallet.wallet.name)
                this.playertype = wallet.symbol;
              }
              if (wallet.wallet.name === "COMPPOINTS") {
                let comp = (wallet.cash.value).toFixed(2)
                this.userCompoints = comp || 0;
              }
            }
          };
        }
      }
    )

    this.PlayerService.onplayerBonuswager().subscribe((res: any) => {

      const { remainingBet, accumulatedBet } = res;
      const remainingBetValue = remainingBet.value;
      const accumulatedBetValue = accumulatedBet.value;
      const totalValue = Number(remainingBetValue) - Number(accumulatedBetValue);
      this.bounsuserWager = totalValue > 0 ? totalValue : 0.00;
      this.lockedBonus = res.lockedBonus.value
      sessionStorage.setItem("bonusWager", this.bounsuserWager)
      sessionStorage.setItem("lockBonus", this.lockedBonus)
    })
  }

  ngOnDestroy() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    if (this.closeSub) {
      this.closeSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  showRegisterPopUp() {
    this.openRegister = true;
  }

  showPopUp(value: string) {
    this.store.dispatch(new loginActions.ResetState());

    const alertCmpFactory = this.componentFactoryResolver.resolveComponentFactory(
      QuickloginComponent
    );
    const hostViewContainerRef = this.alertHost;
    hostViewContainerRef.clear();
    const componentRef = hostViewContainerRef.createComponent(alertCmpFactory);
    componentRef.instance.formState = value;
    componentRef.instance.providerObj = this.provider;

    this.closeSub = componentRef.instance.close.subscribe(() => {
      this.closeSub.unsubscribe();
      hostViewContainerRef.clear();
    });
  }
  showLogOutPopup() {
    this.logoutPopup = true;
  }
  hideLogOutPopup() {
    this.logoutPopup = false;
  }

  onClickLogout() {
    this.router.navigate(['/']);
    this.logoutPopup = false;
    this.store.dispatch(new loginActions.ResetState());
    this.store.dispatch(new cashierActions.ResetState());
    this.store.dispatch(new loginActions.LogoutStart());
    localStorage.removeItem('affcheckid')
    localStorage.removeItem('affCid')
    sessionStorage.clear();
    this.gameService.providerListSubject.next([])
    setTimeout(() => {
      window.location.reload();
    }, 800);
    this.closeGameSession()
    this.slotsService.walletupdate().subscribe((res: any) => {
      console.log(res)
    })
  }

  closeGameSession() {
    this.slotsService.endsession().subscribe(data => { })
    let gameSession = sessionStorage.getItem("closeGameSession")
    let body = {
      "gameSession": gameSession
    }
    if (gameSession) {
      this.slotsService.closeGameSession(body).subscribe((res: any) => {
        console.log(res.success)
        if (res.success) {
          sessionStorage.removeItem("closeGameSession")
        }

      })
    }
  }
  indexValue(i: any) {
    if (i == this.indexId) {
      this.indexId = 1000;
    } else {
      this.indexId = i;
      this.shodrop = !this.shodrop;
    }
  }


  closeMenuNames(data: any) {
    this.closeMenuCoverDiv = false;
    this.getMenuFromPath('home');
    if (window.innerWidth <= 767 && data !== 'My Account' && data !== 'Cashier') {
      this.menuNames = true;
    } else {
      if (window.innerWidth <= 767) {
        this.menuNames = false;
      }
    }

  }

  openMenu() {
    this.menuNames = !this.menuNames;
    if (window.innerWidth <= 767) {
      this.closeMenuCoverDiv = true;
    }
  }

  openarcades(data: any) {
    window.open(data.arcades_GAME_LAUNCH_URL)
  }
  casinogamessuccessPopClose() {
    this.casinomessage = '';
    this.casinogamessuccessPop = false;
  }
  sessionExpiresuccessPopClose() {
    this.router.navigate(['/']);
    this.onClickLogout();
    this.sessionExpiresuccessPop = false;
    this.sessionmessage = "";
    setTimeout(() => {
      window.location.reload();
    }, 800);
  }
  setTheme(data: any) {
    localStorage.setItem('color', data)
    if (data == 'lightTheme') {
      this.lightTheme = true;
    } else {
      this.lightTheme = false;
    }
    let body = document.getElementsByTagName('body')
    body[0].className = ''
    body[0].classList.add(data);
  }

  ngAfterViewInit() {
    $('#carouselExampleIndicators').carousel();
  }

  openIosPop() {
    this.isOpenIosPop = true;
  }
  onCloseIosPop() {
    this.isOpenIosPop = false;
  }
  openPopup(type: string) {
    this.closeAllPopups(); // Close all popups first
    if (type === 'casino') this.showPopupcasino = true;
    if (type === 'instant') this.showPopupInstant = true;
    if (type === 'hot') this.showPopupHot = true;
    if (type === 'sports') this.showPopupSports = true;
  }

  closePopup(type: string) {
    setTimeout(() => {
      if (type === 'casino') this.showPopupcasino = false;
      if (type === 'instant') this.showPopupInstant = false;
      if (type === 'hot') this.showPopupHot = false;
      if (type === 'sports') this.showPopupSports = false;
    }, 100);
  }

  keepPopupOpen(type: string) {
    if (type === 'casino') this.showPopupcasino = true;
    if (type === 'instant') this.showPopupInstant = true;
    if (type === 'hot') this.showPopupHot = true;
    if (type === 'sports') this.showPopupSports = true;
  }

  closeAllPopups() {
    this.showPopupcasino = false;
    this.showPopupInstant = false;
    this.showPopupHot = false;
    this.showPopupSports = false;
  }
  updateActiveRoute(): void {
    const currentRoute = this.router.url.split('/')[1]; // Get the route after the base URL
    this.links.forEach((link, i) => {
      link.active = (link.router === currentRoute); // Set active link 
      if (link.router === currentRoute) {
        this.currentActiveIndex = i; // Update the active index
      }
    });
    console.log(this.links)
  }
  onLinkClickmenu(event: any, item: any) {
    console.log(item)
    this.mobileMenuOpen = false;
    if (item.name == "DEPOSIT" || item.name == "PROFILE") {
      this.openModal(event, item.router)
    } else {
      this.router.navigate([`/${item.router}`]);
    }
  }
  onLinkClick(index: number): void {
    window.scroll(0, 0);
    if (this.links[index].router !== this.router.url.split('/')[1]) {
      this.router.navigate([`/${this.links[index].router}`]);
    }


    // if (index === 0) {
    //   // this.menushow = !this.menushow;
    //   // if (this.menushow) {
    //   //   this.links[0].name = 'BACK';
    //   //   this.links[0].icon = 'fa-arrow-left';
    //   //   this.links.forEach((link, i) => {
    //   //     link.active = (i === index);
    //   //   });
    //   // } else {
    //   //   this.links[0].name = 'MENU';
    //   //   this.links[0].icon = 'fa-bars';
    //   //   this.links[0].active = false
    //   //   this.links.forEach((link, i) => {
    //   //     link.active = (i === index);
    //   //   });
    //   // }

    //   return;
    // } else if (index == 1) {
    //   // this.proiderGamesAll()
    // } else {
    //   console.log(index)
    //   this.closeMenu()
    //   if (this.links[index].router !== this.router.url.split('/')[1]) {
    //     this.router.navigate([`/${this.links[index].router}`]);
    //   }
    //   this.links.forEach((link, i) => {
    //     link.active = (i === index);
    //   });
    // }
    // this.currentActiveIndex = index;
    // // this.links[0].name = 'MENU';
    // // this.links[0].icon = 'fa-bars';
    // this.menushow = false;
  }

  routerLink(index: any) {
    localStorage.setItem('provider', index)
    this.comman.setValue(index);
    this.router.navigate(['/slots'])
  }
  closeMenu(): void {
    this.menushow = false;
    // this.links[0].name = 'MENU';
    // this.links[0].icon = 'fa-bars';
    localStorage.removeItem('P_R_N')
  }


  redirect(data: any) {
    this.router.navigate([`/${data}`])
    this.closeAllPopups()
  }
  onCloseTermsAndCondition() {
    this.isOpenTermsAndCondition = false;
    this.isTermsAndCondition = false
    this.isPrivacyPolicy = false
    this.router.navigate(['/home'])

  }
  copyMessage(val: string) {
    const tempTextarea = document.createElement('textarea');
    tempTextarea.value = val;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, tempTextarea.value.length);
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showCopiedMessage = true;
        setTimeout(() => {
          this.closeMenu()
          this.showCopiedMessage = false;
        }, 2000);
      }
    } catch (err) {
      console.error('Error copying text: ', err);
    }
    document.body.removeChild(tempTextarea);
  }
  filterGamesProvider(): void {
    this.comman.setSearchTerm(this.searchProvider);
    this.router.navigate(['/slots'])

  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.profileAvathar = false;
    this.profileHeader = !this.profileHeader;
  }

  toggleDropdownAvathar(event: MouseEvent): void {
    event.stopPropagation();
    this.profileHeader = false;
    this.profileAvathar = !this.profileAvathar;
  }

  onChangeAvtar(e: any) {
    this.showAvtars = !this.showAvtars;
    this.toggleDropdownAvathar(e);
  }

  selectAvtar(avtar: any) {
    this.selectedAvtarId = avtar.id;
    this.previewAvtar = "data:image/png;base64," + avtar.imageData;
  }

  setAvtar() {
    // alert("hitr")
  }

  openLiveSupport() {
    if (window && (window as any).Tawk_API) {
      (window as any).Tawk_API.maximize();
    } else {
      console.warn('Tawk_API is not available yet.');
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent | Event): void {
    const clickedInsideAvatar = this.avatarDropdownRef?.nativeElement.contains(event.target);
    const clickedInsideBalance = this.balanceDropdownRef?.nativeElement.contains(event.target);

    if (!clickedInsideAvatar) this.profileAvathar = false;
    if (!clickedInsideBalance) this.profileHeader = false;
  }
  proiderGamesAll() {
    this.allproiderGames = true;
  }
  proiderGamesClose() {
    this.allproiderGames = false;
  }

  onOpenPlayerStatistics() {
    this.playerStatisticsSec = !this.playerStatisticsSec;
    this.PlayerService.getPlayerStatistics().subscribe((res) => this.playerStatistics = res);


    this.PlayerService.onPlayerGetPlayerLevels().subscribe((data: any) => {
      if (data) {
        // this.vipLevels = data.playerLevelResponses.sort((a: any, b: any) => a.priority - b.priority);
        this.vipLevels = data.playerLevelResponses
          .sort((a: any, b: any) => a.priority - b.priority)
          .map((level: any) => {
            if (level.name === "Platinum") {
              level.name = "Platinum1";
            } else if (level.name === "Active") {
              level.name = "Platinum2";
            } else if (level.name === "Shark") {
              level.name = "Platinum3";
            }
            return level;
          });

        let totalLevels = this.vipLevels.length;
        let step = totalLevels > 1 ? 100 / (totalLevels - 1) : 100;
        // console.log(this.vipLevels)
        for (let ele of this.vipLevels) {
          if (this.userCompoints >= ele.compPoints) {
            this.vipName = ele.name;
            this.vipName1 = ele.priority;
          }
        }
        console.log(this.vipName)
        const currentRankName = this.vipName || this.vipLevels[0].name;
        this.currentRank = currentRankName === "Iron" ? "Unranked" : currentRankName;

        let nextLevelIndex = this.vipLevels.findIndex((level) => level.name === currentRankName);
        if (nextLevelIndex + 1 < this.vipLevels.length) {
          this.nextRankIcon = this.vipLevels[nextLevelIndex + 1].name;
        } else {
          this.nextRankIcon = "Top Level";
        }

        let minPoints = 0;
        let maxPoints = Infinity
        for (let i = 0; i < this.vipLevels.length; i++) {
          if (this.vipLevels[i].name === this.vipName) {
            minPoints = this.vipLevels[i]?.compPoints || 0;
            maxPoints = this.vipLevels[i + 1]?.compPoints || this.vipLevels[this.vipLevels.length - 1]?.compPoints
          }
        }

        function calculatePercentage(minPoints: number, maxPoints: number, currentPoints: number): number {
          if (maxPoints === minPoints) {
            return 0;
          }

          const percentage = ((currentPoints - minPoints) / (maxPoints - minPoints)) * 100;
          return Math.max(0, Math.min(percentage, 100));
        }

        setTimeout(() => {
          const result = calculatePercentage(minPoints, maxPoints, this.userCompoints);
          console.log(result.toFixed(2) + "%");
          this.vipProgress = result.toFixed(2)
        }, 1000);
      }
    });
  }

  onLaunchClan() {
    this.isLoading = true;
    this.clanIframePop = true;
    this.PlayerService.generateTokenClanApi().subscribe(res => {
      const { message, token } = res;
      if (message === "success") {
        this.urlSafe = this.sanitizer
          .bypassSecurityTrustResourceUrl(token);
      }
      this.isLoading = false;
    });
  }
  changeLanguage(lang: string) {
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }
  toggleMenu(item: any, element: HTMLElement) {
    this.menuNames = true
    console.log(item)
    this.menu.forEach(m => {
      if (m !== item) m.expanded = false;
    });

    item.expanded = !item.expanded;

    if (item.expanded) {
      setTimeout(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
    if (item.name == "Home") {
      this.router.navigate(['/home'])
    } else if (item.name == "Promotions") {
      this.router.navigate(['/promotions'])
    }

  }
  scrollToTop() {
    setTimeout(() => {
      if (this.menuContainer?.nativeElement) {
        this.menuContainer.nativeElement.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 50);
  }



  toggleDropdown_lan() {
    this.openClose = !this.openClose;

    // keep current as temp
    this.tempLang = this.selectedLang;
  }

  selectTempLang(lang: string) {
    this.tempLang = lang;
    this.confirmLang()
  }

  confirmLang() {
    this.selectedLang = this.tempLang;

    localStorage.setItem('lang', this.selectedLang);
    this.translate.use(this.selectedLang);

    this.openClose = false;
  }

  mobileMenuOpen = false;
  selectedMobile: any = null;


  toggleMobileMenu() {
    console.log()
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (!this.mobileMenuOpen) {
      this.selectedMobile = null;
    }
  }
  selectMobileMenu(item: any) {
    console.log('CLICKED:', item);   // 👈 ADD THIS

    if (item.children && item.children.length) {
      if (item.expanded) {
        console.log('expanded:', item.expanded);
        this.selectedMobile = null
      } else {
        this.selectedMobile = item;

      }
    } else {
      this.toggleMobileMenu();
    }
    item.expanded = !item.expanded;
    this.cdr.detectChanges();
  }


  private updateFromUrl(url: string) {
    // parse query params safely
    console.log(url)
    const tree = this.router.parseUrl(url);
    const qp = tree.queryParams || {};


    this.modalType = qp['modal'] || null;

    if (this.modalType) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }

    // debug
    console.log('modalType:', this.modalType);

    if (this.modalType == "deposit") {
      this.popnametranslate = "DEPOSIT"
    }
    else if (this.modalType == "cashout") {
      this.popnametranslate = "CASHOUT"
    }
    else if (this.modalType == "profile") {
      this.popnametranslate = "PROFILE"
    }
    else if (this.modalType == "transactionhistory") {
      this.popnametranslate = "TRANSACTION_HISTORY"
    }
    else if (this.modalType == "casinogamehistory") {
      this.popnametranslate = "GAME_HISTORY"
    }

  }


  openModal(event: any, type: string) {
    // document.documentElement.style.overflow = 'hidden';
    // document.body.style.overflow = 'hidden';

    this.router.navigate([], {
      queryParams: { modal: type },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    this.toggleDropdownAvathar(event)
  }

  closeModal() {
    // document.documentElement.style.overflow = '';
    // document.body.style.overflow = '';
    this.router.navigate([], {
      queryParams: { modal: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  navigatesection(item: any) {

    if (item.router == 'sports' && !this.playerLoggedIn) {
      this.showPopUp("LOGIN")
      this.router.navigate(['/home'])
      return;
    }

    // ✅ save selected provider
    console.log(item)

    // ✅ send event BEFORE navigation (better)
    if (item.router == '/slots' || item.router == '/livecasino' || item.router == '/fishing') {
      localStorage.setItem('P_R_N', item.name);
      localStorage.setItem('FROM_HEADER', 'true');
      this.gamesService.triggerAction(item);
    }
    // ✅ navigate
    if (item.provider == 'Habanero') {
      this.gameLaunch(item)
    } else {
      this.router.navigate([item.router]);
    }

  }

  navigatesectionMobile(item: any) {
    // ✅ save selected provider
    localStorage.setItem('P_R_N', item.name);

    // ✅ send event BEFORE navigation (better)
    if (item.router == '/slots' || item.router == '/livecasino' || item.router == '/fishing') {
      this.gamesService.triggerAction(item);
    }
    // ✅ navigate
    if (item.provider == 'Habanero') {
      this.gameLaunch(item)
    } else {
      this.router.navigate([item.router]);
    }

    this.toggleMobileMenu()
  }

  gameLaunch(item: any) {
    this.slotsreal(item.KeyName, item)
  }

  slotsreal(data: any, gameName: any) {

    if (this.playerLoggedIn) {
      this.keyname = data;
      if (this.tokendata == null) {
        let profile = sessionStorage.getItem('wsessionBD');
        this.slotsService.httpClient(profile, data).subscribe((data: any) => {
          this.slotsdata = data.URL;
          this.tokendata = this.slotsdata.TOKEN;
          if (this.slotsdata) {
            this.gamelunchurl = this.slotsdata.HABANERO_GAMING_URL + 'brandid=' + this.slotsdata.BRAND_ID + '&keyname=' + this.keyname + '&token=' + this.slotsdata.TOKEN + '&mode=real&locale=en';
            this.gamelunchUrl(this.slotsdata, gameName)
          }
        },
        );
      } else if (this.tokendata != null) {
        this.gamelunchurl = this.slotsdata.HABANERO_GAMING_URL + 'brandid=' + this.slotsdata.BRAND_ID + '&keyname=' + this.keyname + '&token=' + this.slotsdata.TOKEN + '&mode=real&locale=en';
        this.gamelunchUrl(this.gamelunchurl, gameName)
      }
    } else if (this.playerLoggedIn == false) {
      this.showPopUp('LOGIN')
    }
  }

  gamelunchUrl(url: any, routePath: any) {
    this.comman.setGameUrl(url);
    this.router.navigate(['/GameLaunch'], {
      queryParams: {
        path: this.router.url.split("/")[1],
        provider: routePath.provider,
        name: routePath.displayName ? routePath.displayName : routePath.gameName
      }
    });
  }

  closeDownloadBanner() {
    this.showDownloadBanner = false;
  }

  trackByMenu(index: number, item: any) {
    return item.id || item.name || index;
  }
  trackByLang(index: number, item: any) {
    return item.code;
  }
} 
